export const NUMBER_OF_TASKS_COMPLETED = 7000
